if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandlerFunction.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandlerFunction(evt) {
        evt.preventDefault();
        console.log("click atc")
        // Code for PDP Limit
        // shows quantity selector when we add the product to cart from pdp
        if (this.submitButton.classList.contains('pdp-submit-button')) {
          let pdpWrapper = this.submitButton.offsetParent;
          let selectedVariantId = pdpWrapper.querySelector('.product-variant-id').value;
          let pdpQuantitySelectors = document.querySelectorAll('.pdp-quantity-selector');
          let pdpAtc = document.querySelector('.pdp-atc');
          let pdpInput = pdpAtc.querySelector('.product-variant-id');
          if(pdpAtc) {
            if(pdpInput.value === selectedVariantId) {
              pdpAtc.classList.add('hidden');
            }
          }
          if(pdpQuantitySelectors) {
            pdpQuantitySelectors.forEach((quantitySelector)=> {
              if (quantitySelector.dataset.qtyVariantId === selectedVariantId) {
                let quantityInput = quantitySelector.querySelector('input')
                quantityInput.value = 1
                quantitySelector.classList.remove('hidden');
              }
            })
          }
          try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            let cartItems = cart.items;
            let itemFound = cartItems.some((item) => {
              if (item.variant_id == selectedVariantId) {
                if (item.quantity == 5) {
                  return true; 
                } else {
                  this.onSubmitHandler(evt);
                  return true; 
                }
              }
              return false;  
            });
      
            if (!itemFound) {
              this.onSubmitHandler(evt);
            }
          } catch (error) {
            console.error('Error fetching cart:', error);
          }
        } else {
          this.onSubmitHandler(evt);
          return true; 
        }
      }
      

      onSubmitHandler(evt) {
        console.log("else condition")
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const _this = this;
        // this.handleErrorMessage();

        if (this.form.closest('ul#product-grid')) {
          this.cart.style.display = 'none';
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        // multiple variant active qnty button 
        const currentProductCard = this.submitButton.closest('.home-pro-card , .wizzy-result-product');
        if (currentProductCard) {
          const activeVariant = currentProductCard.querySelector('.product-form__input label.active');
          if (activeVariant) {
            const activeVariantID = activeVariant.dataset.variantId;
            const qntySelector = currentProductCard.querySelectorAll('.custom-qty-wrapper , .product-form__quantity');
            // const qntySelector = currentProductCard.querySelectorAll('.product-form__quantity');
            console.log("quanity selector")
            qntySelector.forEach((qnty)=> {
              if (qnty.dataset.qtyVariantId === activeVariantID) {
                const input = qnty.querySelector('input.custom-qty-input , input.quantity__input');
                console.log("input.value", input.value);
                if (input && input.value == '0') input.stepUp();
                
                const quantityInput = this.form.querySelector('input[name="quantity"]');
                if (quantityInput && quantityInput.value == '0') quantityInput.value = '1';
                console.log("quantityInput", quantityInput.value)
              }
            });
          } else {
            const qntyBTN = this.closest('.home-pro-card , .wizzy-result-product')?.querySelector('.product-form__quantity , .quantity');
            const input = qntyBTN.querySelector('input.quantity__input');
            if (input && input.value == '0') input.stepUp();
            
            const quantityInput = this.form.querySelector('input[name="quantity"]');
            if (quantityInput && quantityInput.value == '0') quantityInput.value = '1';
          }
        }
        
        // disable all other add to cart and quantity buttons until the product is added to cart
        const targetBtn = evt.target.querySelector('.product-form__buttons button[type="submit"]');
        const addToCartBTNs = document.querySelectorAll('product-form .product-form__buttons button[type="submit"]');
        addToCartBTNs.forEach((btn) => {
          btn.classList.add('disabled');
          console.log("disabled getting added 1");
        });

        const qntyBtns = document.querySelectorAll('.product-form__quantity.active quantity-input .quantity__button');
        qntyBtns.forEach((btn) => {
          btn.classList.add('disabled');
          console.log("disabled getting added 2");
        });

        const formData = new FormData(this.form);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // print formdata
        // for (const [key, value] of formData.entries()) {
        //   console.log(key + ': ' + value);
        // }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              // this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                soldOutMessage.classList.remove('hidden');
              };

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              this.error = true;
              _this.errorCondition = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            
            // Code for PDP Limit (Commented)
            //* commented this code because of product limit in pdp
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (document.body.classList.contains('product')) {
              this.submitButton.classList.remove('disabled');
            }

            if (!_this.errorCondition) {
              const successMSG = document.querySelector('.add-to-cart-pop');
              successMSG?.classList.add('active');
              setTimeout(()=> {
                successMSG?.classList.remove('active');
              }, 3000);

              // multiple variant active qnty button
              const currentProductCard = this.submitButton.closest('.home-pro-card , .wizzy-result-product');
              const activeVariant = currentProductCard?.querySelector('.product-form__input label.active');
              console.log("activeVariant", activeVariant)
              if (activeVariant) {
                const activeVariantID = activeVariant.dataset.variantId;
                const qntySelector = currentProductCard.querySelectorAll('.custom-qty-wrapper , .product-form__quantity');
                // const qntySelector = currentProductCard.querySelectorAll('.product-form__quantity');
                qntySelector.forEach((qnty)=> {
                  if (qnty.dataset.qtyVariantId === activeVariantID) {
                    qnty.classList.add('active');
                    console.log("adding active");
                  }
                });
              } else {
                currentProductCard?.querySelector('.product-form__quantity, .quantity').classList.add('active');
              }

              // enable all other add to cart buttons once the cart is updated
              
              const qntyBtns = document.querySelectorAll('.product-form__quantity.active quantity-input .quantity__button');
              qntyBtns.forEach((btn) => {
                const input = btn.parentElement.querySelector('.quantity__input');
                btn.classList.remove('disabled');
                if (input.value === input.max && btn.name === 'plus') btn.classList.add('disabled');
              });
              addToCartBTNs.forEach((btn) => {
                if (btn !== targetBtn) {
                  btn.classList.remove('disabled');
                }
              });
              const validVariantId = currentProductCard?.querySelector('.product-form__input.product-form__quantity.active')?.dataset.qtyVariantId;
              const DuplicateqntySelector = document.querySelector(`.product-form__input.product-form__quantity[data-qty-variant-id="${validVariantId}"]`);
              const inputElement = DuplicateqntySelector?.querySelector('input');
              if (inputElement && inputElement.value == '0') {
                inputElement.stepUp();
              }
              DuplicateqntySelector?.classList.add('active');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
